import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "filters",
  "aria-label": "Order filters"
}
const _hoisted_2 = { class: "filters__field" }
const _hoisted_3 = { class: "filters__field" }
const _hoisted_4 = { class: "filters__field" }
const _hoisted_5 = { class: "filters__field" }
const _hoisted_6 = { class: "filters__field" }
const _hoisted_7 = { class: "filters__field" }

import { computed, ref, watch } from "vue";
import { getTripTypeOptions } from "@features/Pages/SalesAdminPage/Services/trip-type-options";
import BaseCheckbox from "@shared/Components/Checkbox/BaseCheckbox.vue";
import Dropdown from "@shared/Components/Dropdown/Dropdown.vue";
import Input from "@shared/Components/Input/Input.vue";
import { FiltersOptions } from "@components/Filters/FiltersOptions";


export default /*@__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue", "change", "reset"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localModel = ref<FiltersModel>(createModel(props.modelValue));
const resolvedOptions = computed<FiltersOptions>(() => ({
  locations: props.options?.locations ?? [],
  companies: props.options?.companies ?? [],
  tripTypes: props.options?.tripTypes ?? [],
}));
const tripTypeOptions = computed(() => getTripTypeOptions(resolvedOptions.value.tripTypes));

watch(
  () => props.modelValue,
  (value) => {
    localModel.value = createModel(value);
  },
  { deep: true },
);

function onTextChange(value: string): void {
  updateModel({
    ...localModel.value,
    text: value.trim(),
  });
}

function onDateTimeChange(value: string): void {
  updateModel({
    ...localModel.value,
    dateTime: value,
  });
}

function onLocationChange(value: string): void {
  updateModel({
    ...localModel.value,
    location: normalizeNullableValue(value),
  });
}

function onCompanyChange(value: string): void {
  updateModel({
    ...localModel.value,
    company: normalizeNullableValue(value),
  });
}

function onTripTypeChange(value: string): void {
  updateModel({
    ...localModel.value,
    tripType: normalizeNullableValue(value),
  });
}

function onShowPassedChange(value: boolean): void {
  updateModel({
    ...localModel.value,
    showPassed: value,
  });
}

function reset(): void {
  const emptyModel = createEmptyModel();
  localModel.value = emptyModel;
  emit("update:modelValue", emptyModel);
  emit("reset", emptyModel);
}

function updateModel(value: FiltersModel): void {
  localModel.value = value;
  emit("update:modelValue", value);
  emit("change", value);
}

function createModel(value?: Partial<FiltersModel>): FiltersModel {
  return {
    text: value?.text ?? "",
    dateTime: value?.dateTime ?? "",
    location: value?.location ?? null,
    company: value?.company ?? null,
    tripType: value?.tripType ?? null,
    showPassed: value?.showPassed ?? false,
  };
}

function createEmptyModel(): FiltersModel {
  return {
    text: "",
    dateTime: "",
    location: null,
    company: null,
    tripType: null,
    showPassed: false,
  };
}

function normalizeNullableValue(value: string): string | null {
  const trimmedValue = value.trim();
  return trimmedValue === "" ? null : trimmedValue;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Input, {
        "model-value": localModel.value.text,
        label: "Fritext",
        id: "sales-admin-free-text-filter",
        "onUpdate:modelValue": onTextChange
      }, null, 8 /* PROPS */, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Input, {
        "model-value": localModel.value.dateTime,
        label: "Datum",
        type: "date",
        id: "sales-admin-date-filter",
        "onUpdate:modelValue": onDateTimeChange
      }, null, 8 /* PROPS */, ["model-value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Dropdown, {
        "model-value": localModel.value.location,
        title: "Station",
        id: "sales-admin-location-filter",
        options: resolvedOptions.value.locations,
        defaultValue: "Välj station",
        selectModifier: "container-border",
        "onUpdate:modelValue": onLocationChange
      }, null, 8 /* PROPS */, ["model-value", "options"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Dropdown, {
        "model-value": localModel.value.company,
        title: "Företagsnamn",
        id: "sales-admin-company-filter",
        options: resolvedOptions.value.companies,
        defaultValue: "Välj företag",
        selectModifier: "container-border",
        "onUpdate:modelValue": onCompanyChange
      }, null, 8 /* PROPS */, ["model-value", "options"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Dropdown, {
        "model-value": localModel.value.tripType,
        title: "Typ av resa",
        id: "sales-admin-trip-type-filter",
        keyvalueoptions: tripTypeOptions.value,
        defaultValue: "Välj typ av resa",
        selectModifier: "container-border",
        "onUpdate:modelValue": onTripTypeChange
      }, null, 8 /* PROPS */, ["model-value", "keyvalueoptions"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(BaseCheckbox, {
        id: "sales-admin-show-passed-filter",
        modelValue: localModel.value.showPassed,
        label: 'Visa passerade ordrar',
        checkboxLabel: 'Visa passerade ordrar',
        rootClassModifier: "base-checkbox--no-padding",
        "onUpdate:modelValue": onShowPassedChange
      }, null, 8 /* PROPS */, ["modelValue"])
    ]),
    _createElementVNode("div", { class: "filters__actions" }, [
      _createElementVNode("button", {
        type: "button",
        class: "button button--link filters__reset",
        onClick: reset
      }, " Rensa filter ")
    ])
  ]))
}
}

})